<template>
  <v-row>
    <v-col cols="12" md="12">
      <BaseBlock title="Page ouverte pour utilisateurs non-authentifiés">
        <h2 class="subtitle-1 font-weight-bold">
          Page ouverte pour utilisateurs non-authentifiés
        </h2>
        <p>
          Cette page est accessible à l'ensemble des utilisateurs non connectés
        </p>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "OnlyAnonPage",
  components: { BaseBlock },
};
</script>
